import styled from "styled-components";
import { breakpoints } from "../../../constants/media";

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  flex-direction: row;
  background-color: var(--white);

  .titleContainer {
    width: 100%;
    display: flex;
    justify-content: center;
  }

  h2 {
    width: 100%;
    text-align: center;
    font-family: Raleway;
    font-style: normal;
    font-weight: bold;
    font-size: 1.8em;
    color: var(--black);
    margin: 0px 0px 45px 0px;
  }

  .hidden {
    display: none !important;
  }

  .marcadoresContainer {
    width: 100%;
    max-width: 535px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    flex-direction: row;
  }

  .marcadoresContainer div {
    width: 33.3%;
    max-width: 150px;
    margin: 0px 0px 0px 0px;
  }

  .marcadoresContainer div span {
    height: 7px;
    width: 100%;
    background-color: var(--lightgray2);
    content: "";
    display: block;
    border-radius: 13px;
  }

  #pasoUno {
    background-color: var(--orange) !important;
  }

  .activo {
    background-color: var(--lightgray) !important;
    box-shadow: 0 0 0 rgba(152, 152, 154, 0.7);
    animation: pulse 1.4s infinite;
  }

  .hecho {
    background-color: var(--orange) !important;
  }

  @-webkit-keyframes pulse {
    0% {
      -webkit-box-shadow: 0 0 0 0 rgba(152, 152, 154, 0.7);
    }
    50% {
      -webkit-box-shadow: 0 0 0 15px rgba(152, 152, 154, 0);
    }
    100% {
      -webkit-box-shadow: 0 0 0 0 rgba(152, 152, 154, 0);
    }
  }
  @keyframes pulse {
    0% {
      -moz-box-shadow: 0 0 0 0 rgba(152, 152, 154, 0.7);
      box-shadow: 0 0 0 0 rgba(152, 152, 154, 0.7);
    }
    50% {
      -moz-box-shadow: 0 0 0 15px rgba(152, 152, 154, 0);
      box-shadow: 0 0 0 15px rgba(152, 152, 154, 0);
    }
    100% {
      -moz-box-shadow: 0 0 0 0 rgba(152, 152, 154, 0);
      box-shadow: 0 0 0 0 rgba(152, 152, 154, 0);
    }
  }

  .marcadoresContainer div p {
    width: 100%;
    text-align: center;
    font-family: Raleway;
    font-style: normal;
    font-weight: 600;
    font-size: 15px;
    color: var(--black);
    margin: 15px 0px 0px 0px;
  }

  // 1440px Desktop ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.desktop1440}) {
    // Text
    .marcadoresContainer div p {
      font-size: 0.96em;
    }
  }

  // 1024px Tablet ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.tablet1024}) {
    .marcadoresContainer {
      max-width: 450px;
    }

    .marcadoresContainer div {
      max-width: 110px;
    }

    h2 {
      max-width: 400px;
    }
  }

  // 651px Mobile ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.mobile651}) {
    .marcadoresContainer {
      max-width: 380px;
    }

    .marcadoresContainer div {
      max-width: 105px;
    }
  }

  // 414px Mobile ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.mobile414}) {
    .marcadoresContainer {
      max-width: 330px;
    }

    .marcadoresContainer div {
      max-width: 93px;
    }
  }

  // 375px Mobile ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.mobile375}) {
    .marcadoresContainer {
      max-width: 300px;
    }

    .marcadoresContainer div {
      max-width: 85px;
    }
  }

  // 350px Mobile ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.mobile350}) {
    .marcadoresContainer {
      max-width: 250px;
    }

    .marcadoresContainer div {
      max-width: 70px;
    }

    h2 {
      max-width: 250px;
    }
  }
`;

export default Container;
